import React from 'react';
import RestBanner from '../rest-banner/RestBanner';
// import aboutBannerImg from './'
import './app.aboutus.scss';

function AppAboutus(props) {
    return (
      <React.Fragment>
        <RestBanner heading="ABOUT US" img={'./project_rest.jpg'}/>
        <section id="res-aboutus">
          <div className='container'>
            <div className="row">
              {/* <div className="left">
                <div className='about-img'>
                  <img src="project-2.jpg" alt="about"/>
                </div>
              </div> */}
              <div className="right">
                {props.AboutUs && props.AboutUs.map((AboutUs,index) => (
                  <p key={index}>{AboutUs.desc}</p>
                ))}
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    )
}

export default AppAboutus;
